import { track, logError } from '@tracking';
import getShopId from '@core/reducers/shop/selectors/getShopId';
import getBusinessType from '@results/selectors/getBusinessType';

const EVENT_NAME = 'swimlane.shown';

const trackSwimlaneShown = (products, swimlaneTitle, swimlanePosition) => (
  _,
  getState,
) => {
  try {
    const state = getState();
    const shopId = getShopId(state);
    const businessType = getBusinessType(state);
    const payload = {
      shopId,
      businessType,
      swimlaneTitle,
      swimlaneType: 'product',
      screenType: 'shop.details',
      swimlanePosition,
      swimlaneContent: products.map(product => product.id).toString(),
    };
    track(EVENT_NAME, payload);
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default trackSwimlaneShown;
